export default function Section1() {
  return (
    <div className="w-full bg-white Section1 py-[30px] md:py-[50px]">

      {/* Main Page Heading */}
      <h1 className="text-center text-black text-[32px] md:text-[42px] font-bold mb-20 leading-[32px] md:leading-[41px]">
        Web Development Services
      </h1>

      {/* Hero Content */}
      <div className="w-[90%] md:w-[85%] mx-auto flex flex-col md:flex-row items-center justify-between gap-10">

        {/* Left Content */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-[26px] md:text-[30px] font-bold text-[#DA2128] -mt-10 md:mt-0 leading-[34px] mb-6">
            World-Class Web Development Agency for Growing Brands
          </h2>

          <p className="text-[15px] md:text-[18px] text-[#444444] leading-[26px] mb-10 max-w-[500px] mx-auto md:mx-0">
            We provide professional website design and development services, building scalable,
            high-performing websites and apps that increase conversions and drive global growth.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a
              href="https://mean3.com/contact-mean3"
              className="bg-[#DA2128] hover:bg-[#b71c22] text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300"
            >
              Get a Free Consultation
            </a>

            <a
              href="https://mean3.com/contact-mean3"
              className="border border-[#DA2128] text-[#DA2128] hover:bg-[#DA2128] hover:text-white text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300"
            >
              View Our Work
            </a>
          </div>
        </div>

        {/* Right Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src="/assets/e-commerce-journey-WebDevPage.png"
            alt="Web Development Illustration"
            className="w-[90%] md:w-[80%] max-w-[500px]"
          />
        </div>
      </div>

<div className="w-[90%] md:w-[85%] mx-auto mt-24">
  <div className="bg-[#F9F9F9] rounded-[16px] py-14 px-6 md:px-12 shadow-sm">

    <h3 className="text-center text-[22px] md:text-[28px] font-bold text-black mb-3">
      Our <span className="text-[#DA2128]">Achievements</span>
    </h3>

    <p className="text-center text-[#666] text-[14px] md:text-[16px] mb-12 max-w-[620px] mx-auto">
      Recognized by leading platforms, partners, and global technology ecosystems.
    </p>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center place-items-center">

      <img
        src="/assets/go-awards-logo 1.png"
        alt="Go Global Awards"
        className="max-h-[100px] transition-all duration-300"
      />

      <img
        src="/assets/fastest-growing-brand-award-of-2021 1.png"
        alt="Fastest growing brand"
        className="max-h-[100px] transition-all duration-300"
      />

      <img
        src="/assets/shopify-experts.png"
        alt="Shopify Experts"
        className="max-h-[100px] transition-all duration-300"
      />
    </div>
  </div>
</div>


    </div>
  );
}
